export default "__VITE_ASSET__BrggZ2g0__"